const YoutubeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8144 5.97438L18.8202 5.97485L18.8261 5.97528C19.5618 6.03024 19.9519 6.16586 20.1667 6.29016C20.343 6.39215 20.4985 6.54013 20.6468 6.86637C20.8144 7.23506 20.9575 7.80297 21.0481 8.69366C21.1376 9.57478 21.1667 10.6654 21.1667 12.0334C21.1667 13.4011 21.1377 14.498 21.0479 15.3868C20.9572 16.2859 20.8135 16.8636 20.6443 17.2392C20.4939 17.5731 20.3394 17.7155 20.1759 17.8089C19.9749 17.9236 19.5985 18.0524 18.8728 18.0886L18.8689 18.0888L18.865 18.089C15.6395 18.263 8.39766 18.2633 5.15536 18.0901C4.43159 18.0342 4.04633 17.8999 3.8333 17.7766C3.65701 17.6746 3.50154 17.5266 3.35323 17.2004C3.18562 16.8317 3.04248 16.2638 2.95194 15.3731C2.86237 14.492 2.83333 13.4014 2.83333 12.0334C2.83333 10.6654 2.86237 9.57478 2.95194 8.69366C3.04248 7.80297 3.18562 7.23506 3.35323 6.86637C3.50154 6.54013 3.65701 6.39215 3.8333 6.29016C4.04815 6.16586 4.43817 6.03024 5.17394 5.97528L5.17977 5.97485L5.18558 5.97438C8.38426 5.71554 15.6157 5.71554 18.8144 5.97438ZM1 12.0334C1 17.5522 1.45833 19.5994 5.03333 19.8665C8.33333 20.0445 15.6667 20.0445 18.9667 19.8665C22.5417 19.6885 23 17.5522 23 12.0334C23 6.5146 22.5417 4.46732 18.9667 4.20028C15.6667 3.93324 8.33333 3.93324 5.03333 4.20028C1.45833 4.46732 1 6.5146 1 12.0334ZM10.5766 14.9498C9.96712 15.2457 9.25 14.8154 9.25 14.1537V9.91317C9.25 9.25146 9.96711 8.82109 10.5766 9.11701L14.9435 11.2373C15.6192 11.5653 15.6192 12.5015 14.9435 12.8296L10.5766 14.9498Z"
        fill="#0E0E0E"
      />
    </svg>
  );
};

export default YoutubeIcon;
